import { useEffect } from 'react';
import { mutate } from 'swr';
import i18n from 'src/locales/i18n';
import { useGetMe } from 'src/api/user_api';

export function toShortLangCode(languageCode) {
  const code = languageCode?.split('-')[0];
  return (i18n.options.supportedLngs ?? []).includes(code) ? code : 'en';
}

export function useUserLanguage() {
  const { user } = useGetMe();
  const languageCode = user?.languageCode;

  useEffect(() => {
    if (!languageCode) return;

    const next = toShortLangCode(languageCode);
    if (next === i18n.language) return;

    i18n.changeLanguage(next);
    mutate(() => true);
  }, [languageCode]);
}
